import antdPtPT from "antd/es/locale/pt_PT";
import ptLang from "./entries/pt_PT";

const AppLocale = {
  antd: antdPtPT,
  pt: ptLang,
};

export default AppLocale;
